// Verifica tags sem conteúdo de texto: headings, links, parágrafos e labels.
const checkEmptyTag = (content, report) => {
  const errors = [];

  const elements = content.querySelectorAll('h1,h2,h3,h4,h5,h6,a,p,label');

  elements.forEach((el) => {
    if (el.textContent.trim().length !== 0) return;
    if (el.closest('[aria-hidden="true"], [hidden]')) return;
    if (el.querySelector('img') || el.hasAttribute('aria-label')) return;

    errors.push({
      msg: `Elemento <strong>${el.tagName}</strong> sem conteúdo textual`,
      el,
    });
  });

  if (errors.length) {
    report.push({ title: 'Elementos sem conteúdo textual', errors });
  }
};

export default checkEmptyTag;
